import { useState } from "react";
import { motion } from "framer-motion";
import { AUDIENCES, EMOJIS } from "../lib/api";

const labelOf = (id) => {
  const a = AUDIENCES.find((x) => x.id === id);
  return a ? (a.sub ? `${a.label} (${a.sub})` : a.label).replace("\u00ad", "") : id;
};

const when = (iso) => {
  const d = new Date(iso);
  return isNaN(d) ? "" : d.toLocaleString("nl-NL", { dateStyle: "medium", timeStyle: "short" });
};

export const ReviewsList = ({ data }) => {
  const all = Array.isArray(data?.reviews) ? data.reviews : [];
  const [filter, setFilter] = useState("all");
  const countFor = (id) => all.filter((r) => Array.isArray(r.audience) && r.audience.includes(id)).length;
  const reviews = filter === "all" ? all : all.filter((r) => Array.isArray(r.audience) && r.audience.includes(filter));
  const average = reviews.length ? Math.round((reviews.reduce((s, r) => s + (r.rating || 0), 0) / reviews.length) * 10) / 10 : 0;
  const chip = (on) => `shrink-0 rounded-full border px-3 py-1.5 text-xs transition-colors ${on ? "bg-[var(--amber)] border-[var(--amber)] text-[var(--ink)] font-bold" : "border-[var(--line)] text-[var(--muted)] hover:text-[var(--paper)]"}`;
  return (
    <div data-testid="saved-reviews-drawer" className="flex-1 flex flex-col min-h-0 px-5 sm:px-10 pt-6 max-w-3xl w-full mx-auto">
      <p className="text-xs uppercase tracking-[0.3em] text-[var(--muted)]">Ontgrendeld · het archief</p>
      <div className="flex items-end gap-6 mt-2 mb-4">
        <h2 className="font-display text-4xl sm:text-5xl font-light">
          <span data-testid="reviews-average" className="text-[var(--amber)]">{average}</span>
          <span className="text-xl text-[var(--muted)]">/10</span>
        </h2>
        <span data-testid="reviews-count" className="text-sm text-[var(--muted)] pb-2">{reviews.length} {reviews.length === 1 ? "review" : "reviews"}</span>
      </div>
      <div data-testid="department-filter" className="flex gap-2 overflow-x-auto no-scrollbar pb-4 -mx-5 px-5 sm:mx-0 sm:px-0 sm:flex-wrap">
        <button data-testid="filter-all" onClick={() => setFilter("all")} className={chip(filter === "all")}>Alle ({all.length})</button>
        {AUDIENCES.map((a) => (
          <button key={a.id} data-testid={`filter-${a.id}`} onClick={() => setFilter(a.id)} className={chip(filter === a.id)}>
            {a.label.replace("\u00ad", "")} ({countFor(a.id)})
          </button>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto no-scrollbar pb-8 space-y-3">
        {reviews.length === 0 && <p data-testid="reviews-empty" className="text-[var(--muted)]">{filter === "all" ? "Nog geen reviews." : "Nog geen reviews voor deze afdeling."}</p>}
        {reviews.map((r, i) => (
          <motion.div
            key={r.id}
            data-testid={`review-item-${r.id}`}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: Math.min(i * 0.05, 0.6) }}
            className="flex gap-4 rounded-2xl border border-[var(--line)] bg-[var(--ink-2)] p-4"
          >
            <div className="text-3xl">{EMOJIS[(r.rating || 1) - 1]?.e}</div>
            <div className="min-w-0 flex-1">
              <div className="flex justify-between gap-3 text-xs text-[var(--muted)] font-mono-clock">
                <span className="text-[var(--amber)]">{r.rating}/10</span>
                <span>{when(r.created_at)}</span>
              </div>
              <p className="mt-1 font-display italic text-[var(--paper)] break-words">{r.comment || "— geen woorden, alleen gevoel —"}</p>
              {Array.isArray(r.audience) && r.audience.length > 0 && (
                <div data-testid={`review-audience-${r.id}`} className="mt-2 flex flex-wrap gap-1.5">
                  {r.audience.map((a) => (
                    <span key={a} className="rounded-full border border-[var(--line)] px-2 py-0.5 text-xs text-[var(--muted)]">{labelOf(a)}</span>
                  ))}
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};
